document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-gglux-thumb]');

  if (!thumb) return;

  event.preventDefault();
  event.stopPropagation();

  const card = thumb.closest('[data-gglux-product-card]');
  if (!card) return;

  const mainImage = card.querySelector('.gglux-card__main-image');
  const mainLink = card.querySelector('.gglux-card__media');
  const variantInput = card.querySelector('[data-gglux-variant-input]');
  const priceWrap = card.querySelector('[data-gglux-price-wrap]');
  const price = card.querySelector('[data-gglux-price]');
  const compareAt = card.querySelector('[data-gglux-compare-at]');
  const addButton = card.querySelector('[data-gglux-add]');
  const addText = card.querySelector('[data-gglux-add-text]');

  if (mainImage) {
    const nextSrc = thumb.dataset.mainSrc;
    const nextSrcset = thumb.dataset.mainSrcset;
    const nextAlt = thumb.dataset.mainAlt;

    if (nextSrc) mainImage.src = nextSrc;
    if (nextSrcset) mainImage.srcset = nextSrcset;
    if (nextAlt) mainImage.alt = nextAlt;
  }

  card.querySelectorAll('[data-gglux-thumb]').forEach((button) => {
    const isActive = button === thumb;
    button.classList.toggle('is-active', isActive);

    if (isActive) {
      button.setAttribute('aria-current', 'true');
    } else {
      button.removeAttribute('aria-current');
    }
  });

  if (thumb.dataset.variantId && variantInput) {
    variantInput.value = thumb.dataset.variantId;
  }

  if (thumb.dataset.variantUrl && mainLink) {
    mainLink.href = thumb.dataset.variantUrl;
  }

  if (thumb.dataset.price && price) {
    price.textContent = thumb.dataset.price;
  }

  if (compareAt) {
    if (thumb.dataset.compareAt) {
      compareAt.textContent = thumb.dataset.compareAt;
      compareAt.hidden = false;
    } else if (thumb.dataset.variantId) {
      compareAt.textContent = '';
      compareAt.hidden = true;
    }
  }

  if (thumb.dataset.available && addButton && addText) {
    const available = thumb.dataset.available === 'true';
    card.dataset.ggluxAvailable = String(available);
    addButton.disabled = !available;
    addText.textContent = available ? 'Add to Cart' : 'Sold Out';

    if (priceWrap) {
      priceWrap.hidden = !available;
      priceWrap.setAttribute('aria-hidden', String(!available));
    }
  }
});

(() => {
  const getActiveTagHandles = () => {
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const collectionsIndex = pathParts.indexOf('collections');
    const collectionHandle = pathParts[collectionsIndex + 1];
    const rawTags = pathParts[collectionsIndex + 2];

    if (collectionsIndex === -1 || collectionHandle !== 'all' || !rawTags) {
      return [];
    }

    return decodeURIComponent(rawTags)
      .split('+')
      .map((handle) => handle.trim())
      .filter(Boolean);
  };

  const params = new URLSearchParams(window.location.search);
  const activeTagHandles = getActiveTagHandles();
  const activeSaleFilters = (params.get('gglux_sale') || '')
    .split(',')
    .map((range) => range.trim())
    .filter(Boolean);

  document.querySelectorAll('[data-gglux-filter-handle], [data-gglux-all-link]').forEach((link) => {
    const linkHandle = link.dataset.ggluxFilterHandle;
    const isActive = linkHandle ? activeTagHandles.includes(linkHandle) : activeTagHandles.length === 0;

    link.classList.toggle('is-active', isActive);

    if (isActive) {
      link.setAttribute('aria-current', 'page');
    } else {
      link.removeAttribute('aria-current');
    }
  });

  document.querySelectorAll('[data-gglux-tag-filter]').forEach((input) => {
    input.checked = activeTagHandles.includes(input.value);
  });

  document.querySelectorAll('[data-gglux-sale-filter]').forEach((input) => {
    input.checked = activeSaleFilters.includes(input.value);
  });

  const isInSaleRange = (discount, range) => {
    switch (range) {
      case 'up-30':
        return discount > 0 && discount <= 30;
      case '30-50':
        return discount > 30 && discount <= 50;
      case '50-60':
        return discount > 50 && discount <= 60;
      case '60-plus':
        return discount > 60;
      default:
        return true;
    }
  };

  if (activeSaleFilters.length) {
    document.querySelectorAll('[data-gglux-product-card]').forEach((card) => {
      const discount = Number(card.dataset.ggluxDiscount || 0);
      const shouldShow = activeSaleFilters.some((range) => isInSaleRange(discount, range));
      card.classList.toggle('is-hidden-by-sale', !shouldShow);
    });
  }

  const drawer = document.querySelector('[data-gglux-filter-drawer]');
  const openButtons = document.querySelectorAll('[data-gglux-filter-open]');
  const closeButtons = document.querySelectorAll('[data-gglux-filter-close]');
  const filterForm = document.querySelector('[data-gglux-filter-form]');
  const sortSelect = document.querySelector('#GGLuxSortBy');

  sortSelect?.addEventListener('change', () => {
    const nextUrl = new URL(window.location.href);

    if (sortSelect.value) {
      nextUrl.searchParams.set('sort_by', sortSelect.value);
    } else {
      nextUrl.searchParams.delete('sort_by');
    }

    nextUrl.searchParams.delete('page');
    window.location.href = `${nextUrl.pathname}${nextUrl.search}`;
  });

  const openDrawer = () => {
    if (!drawer) return;

    drawer.hidden = false;
    document.body.classList.add('gglux-filter-open');
    openButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
  };

  const closeDrawer = () => {
    if (!drawer) return;

    drawer.hidden = true;
    document.body.classList.remove('gglux-filter-open');
    openButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', openDrawer);
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeDrawer);
  });

  document.querySelectorAll('.gglux-filter-drawer__toggle').forEach((toggle) => {
    const options = toggle.nextElementSibling;
    if (!options) return;

    toggle.setAttribute('aria-expanded', 'true');

    toggle.addEventListener('click', () => {
      const isCollapsed = options.hasAttribute('hidden');
      options.toggleAttribute('hidden', !isCollapsed);
      toggle.setAttribute('aria-expanded', String(isCollapsed));

      const state = toggle.querySelector('span');
      if (state) state.textContent = isCollapsed ? '-' : '+';
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer && !drawer.hidden) {
      closeDrawer();
    }
  });

  filterForm?.addEventListener('submit', (event) => {
    event.preventDefault();

    const baseUrl = filterForm.dataset.baseUrl || '/collections/all';
    const selectedTags = Array.from(filterForm.querySelectorAll('[data-gglux-tag-filter]:checked'))
      .map((input) => input.value)
      .filter(Boolean);
    const selectedSaleRanges = Array.from(filterForm.querySelectorAll('[data-gglux-sale-filter]:checked'))
      .map((input) => input.value)
      .filter(Boolean);
    const nextUrl = new URL(window.location.origin + baseUrl + (selectedTags.length ? `/${selectedTags.join('+')}` : ''));

    if (selectedSaleRanges.length) {
      nextUrl.searchParams.set('gglux_sale', selectedSaleRanges.join(','));
    }

    const currentSort = params.get('sort_by');
    if (currentSort) {
      nextUrl.searchParams.set('sort_by', currentSort);
    }

    window.location.href = `${nextUrl.pathname}${nextUrl.search}`;
  });
})();
